//#region  Start Scope: imports
import React, { Component } from 'react';
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import { withRouter } from '~HOC';
import { numberWithCommas } from '../../../../utils/consts/index';
import { dateDiff } from '../../../../utils/consts/months';
import {
  FlightPath,
  Button,
  FlightDetails,
  PriceDetails,
  FormatLastNumberColor,
  Tooltip,
  Modal,
  WantFlight,
} from '../../../../component';
import {
  ArrivalAirplaneIcon,
  DepartureAirplaneIcon,
  InfoCircleIcon,
  DownOutlineIcon,
  UpOutlineIcon,
  CircleIcon,
  CabinTypeIcon,
  CoinIcon,
  ChevronDownIcon,
} from '~svg';

import {
  getDayDiff,
  convertToCamelCase,
  returnDayWithMonthName,
  returnShamsiDayWithMonthName,
  returnWeeekDay,
  createDetailPriceListFlight,
  returnAirlineLogos,
} from '../../../../utils/utility/booking';
import momentjs from 'moment-jalaali';
import './flightInformation.scss';
//#endregion
class FlightInformation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showMoreFlag: [],
      take: 20,
      selectedRow: -1,
      showMore: false,
      showModal: false,
      maxPrice: '0',
    };
  }

  //#region Start Scope: Component Life cycle
  UNSAFE_componentWillReceiveProps = (nextprops) => {
    if (!Object.is(this.props, nextprops)) {
      // check to show shome more button or not
      this.setState((state) => {
        state.showMore =
          nextprops.flightList.length > state.take ? true : false;
        state.selectedRow = -1;
        state.showMoreFlag = [];
        return state;
      });
    }
  };
  //Set showMore Flag to show or hide show more button
  componentDidMount = () => {
    let { take } = this.state;
    if (window.screen.width <= 768) {
      window.addEventListener('scroll', (event) => {
        if (window.innerHeight <= event.currentTarget.scrollY) {
          this.ShowMoreFlight();
        }
      });
    }
    this.setState({
      showMore: this.props.flightList.length > take,
    });
  };

  //#endregion

  //show day count difference for aarive time
  makeArriveMessage = (dayDiff) => {
    let { name } = this.props.language;
    return `${this.props.intl.formatMessage({
      id: 'booking.arrivein',
      defaultMessage: 'booking.arrivein',
    })} ${Math.abs(dayDiff)} ${
      dayDiff > 0
        ? this.props.intl.formatMessage({
            id: 'booking.nextdays',
            defaultMessage: 'booking.nextdays',
          })
        : this.props.intl.formatMessage({
            id: 'booking.previousedays',
            defaultMessage: 'booking.previousedays',
          })
    }${dayDiff > 1 && name === 'en' ? 's' : ''}`;
  };

  selectRow = (index) => {
    let { showMoreFlag } = this.state;
    showMoreFlag[index] = !showMoreFlag[index];
    // if click in current open flight close it
    if (this.state.selectedRow === index)
      this.setState({
        selectedRow: -1,
        showMoreFlag,
      });
    //set current index to slected row to open details card
    else
      this.setState({
        selectedRow: index,
        showMoreFlag,
      });
  };
  //change take and plus previous take with 20
  ShowMoreFlight = () => {
    let { take } = this.state;
    let length = this.props.flightList.length;
    take += 20;
    this.setState({
      take,
      showMore: length > take ? true : false,
    });
  };

  hidePriceModal = () => {
    this.setState({ currentIndex: -1 });
  };
  // create list of price for each passenget type and total price
  setPriceList = (item, index) => {
    let { parsedQueryStr } = this.props;
    let { priceList } = this.state;
    let { name } = this.props.language;
    priceList = createDetailPriceListFlight(item, parsedQueryStr, name);
    this.setState({ priceList, currentIndex: index });
  };

  renderWantFlightModal = () => {
    let { showModal } = this.state,
      { intl } = this.props;
    return (
      <Modal
        isOpen={showModal}
        onClose={() => this.setState({ showModal: false })}
        title={intl.formatMessage({ id: 'booking.setmaxprice' })}
      >
        <div
          className={`d-flex w-100 modal-body pt-0 font-smaller text-capitalize text-center align-items-center justify-content-between`}
        >
          <WantFlight />
        </div>
      </Modal>
    );
  };

  //#endregion
  //#region  Render
  //show flight airport and flight dateTime informations and tooltip for airport
  renderCityInfo = (item, index, indx) => {
    let { name, direction } = this.props.language,
      { intl } = this.props,
      flightType = this.props.flightType;
    // compare dates if arrival date time is in next days or previous day because of timezone
    let dayDiff = getDayDiff(
      item.Flights[0].DepartureDateTime,
      item.Flights[item.Flights.length - 1].ArrivalDateTime,
    );

    if (item) {
      return (
        <div className="d-md-flex flex-column align-items-center justify-content-center col-sm-9 col-10 p-0 ">
          <div
            className={`d-flex align-items-center  justify-content-center w-100 py-3`}
          >
            <div className="col-3 d-flex justify-content-center  font-small font-xxl-normal ">
              <div className="font-weight-bold d-flex flex-column justify-content-center">
                <div
                  className={`d-flex flex-column   align-items-center text-dark  ${
                    flightType === 'roundtrip' && index !== 0
                      ? ''
                      : 'font-weight-bold'
                  }`}
                >
                  {/* departure  time */}
                  {item.Flights[0].DepartureDateTime.split('T')[1].substring(
                    0,
                    5,
                  )}
                </div>
                <div className="d-flex flex-column align-items-center text-third pt-md-1 pt-0 pt-sm-0">
                  <div className="font-small  text-center font-msmall font-xxl-small">
                    {item.Flights[0].DepartureAirport.CityName[name]}
                  </div>
                </div>
              </div>
            </div>
            {/* show airplane image to show origin and destination */}

            {this.renderFlightRouteImage(item, index, indx)}

            <div className="font-weight-bold d-flex flex-column justify-content-center col-3 p-0 font-small font-xxl-normal position-relative ">
              <div className="px-1 d-flex font-weight-normal align-items-center justify-content-center text-dark col-12">
                <div
                  className={`${
                    dayDiff === 0 ? 'col-12' : 'col-8 col-sm-5'
                  } justify-content-center d-flex px-1`}
                >
                  {item.Flights[item.Flights.length - 1].ArrivalDateTime.split(
                    'T',
                  )[1].substring(0, 5)}
                </div>
                {dayDiff !== 0 && (
                  <div
                    className={`${
                      direction === 'rtl'
                        ? 'diff-day-container-rtl'
                        : 'diff-day-container-ltr'
                    } `}
                  >
                    <Tooltip
                      position={direction === 'rtl' ? 'right' : 'left'}
                      content={this.makeArriveMessage(dayDiff)}
                      direction={direction}
                      backgroundColor="warning"
                      textColor="dark"
                      contentXPadding="px-0"
                    >
                      <div
                        className="d-flex px-0  text-captalize text-secondary align-items-center font-weight-bold justify-content-center cursor-pointer"
                        style={{ direction: 'ltr' }}
                      >
                        {dayDiff > 0 ? `(+${dayDiff})` : dayDiff}
                      </div>
                    </Tooltip>
                  </div>
                )}
              </div>
              <div
                className={`d-flex  col-12 p-0 pt-md-1 pt-0 pt-sm-0 justify-content-center font-weight-bold text-third  font-msmall font-xxl-small`}
              >
                {
                  //city of arrival airport
                  item.Flights[item.Flights.length - 1].ArrivalAirport.CityName[
                    name
                  ]
                }
              </div>
            </div>
          </div>
        </div>
      );
    } else return '';
  };
  //show airplane and route image
  renderFlightRouteImage(item, index, indx) {
    const { name, direction } = this.props.language,
      selectedAirport = JSON.parse(sessionStorage.getItem('selectedAirport')),
      isInternational =
        selectedAirport.filter(
          (item) =>
            item.destination.countryCode !== 'IR' ||
            item.origin.countryCode !== 'IR',
        ).length > 0;
    return (
      <div className="col-6  px-0  justify-content-center font-smaller">
        <div className="d-flex flex-column">
          <div className="pb-2 d-flex justify-content-center align-items-center  font-weight-bold text-primary">
            {item.StopCount === 0 && (
              <FormattedMessage
                id={'booking.nonstop'}
                defaultMessage="booking.nonstop"
              />
            )}
            {item.StopCount > 0 && (
              <>
                <div className="d-md-none d-flex justify-content-center align-items-center  font-weight-bold text-primary">
                  <span className="px-2">{item.StopCount}</span>
                  <FormattedMessage
                    id={
                      item.StopCount === 0
                        ? 'booking.nonstop'
                        : 'booking.stopcount'
                    }
                    defaultMessage="booking.nonstop"
                  />
                </div>
              </>
            )}
          </div>

          <div className="d-flex justify-content-center position-relative">
            <div
              className="d-none d-sm-none d-md-block w-100"
              style={{ height: 30 }}
            >
              <FlightPath direction={direction} />
            </div>
            <div
              className="d-flex position-relative justify-content-center align-items-center d-md-none d-sm-block d-block 
            w-100 font-smaller font-sm-msmall font-md-small   "
            >
              <div
                style={{ height: 22 }}
                className="d-flex w-100 border text-nowrap border-2 align-items-center justify-content-center  rounded-pill  text-third"
              >
                <FormattedMessage id="booking.duration" />
                {` : ${item.ElapsedTime.slice(0, 2)}:${item.ElapsedTime.slice(
                  2,
                )}`}
              </div>
              {/* {item.StopCount > 0 ? (
                <div
                  className="d-md-flex d-none justify-content-center position-absolute w-100"
                  style={{ top: -4, height: 32 }}
                >
                  {this.renderCircleStopCount(item, index, indx)}
                </div>
              ) : (
                <></>
              )} */}
            </div>
            <div
              className="d-md-flex d-none justify-content-center position-absolute w-100"
              style={{ top: -8, height: 32 }}
            >
              {this.renderCircleStopCount(item, index, indx)}
            </div>
          </div>

          <div className="d-flex w-100 ">
            <div className="d-flex justify-content-center align-items-center p-0 m-0 w-100 text-nowrap  ">
              {direction === 'rtl' ? (
                <span
                  className={`p-1 font-weight-bold  ${
                    item.isCharter ? 'text-danger' : 'text-secondary'
                  }  `}
                >
                  <FormattedMessage
                    id={`booking.${item.isCharter ? 'charter' : 'systemic'}`}
                    defaultMessage={`booking.${
                      item.isCharter ? 'charter' : 'systemic'
                    }`}
                  />
                  {' - '}
                </span>
              ) : (
                <></>
              )}
              <div className="font-weight-normal text-third   d-flex  justify-content-center">
                <span
                  className={`py-1 ${
                    item.Flights[0].BookingClassAvails.ResBookDesigCabinName[
                      'en'
                    ] === 'Economy'
                      ? 'text-third  '
                      : item.Flights[0].BookingClassAvails.ResBookDesigCabinName[
                          'en'
                        ].toLowerCase() === 'business'
                      ? 'text-primary-light'
                      : 'text-gold'
                  } font-weight-bold `}
                >
                  {`${item.Flights[0].BookingClassAvails.ResBookDesigCabinName[name]}`}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  /* show dot for each stop count */
  renderCircleStopCount(flight, indx, ind) {
    let { direction } = this.props.language;

    if (flight) {
      let { name } = this.props.language,
        arr = [];

      for (let i = 0; i < flight.StopCount; i++) {
        arr[i] = i;
      }

      return arr.map((item, index) => (
        <div
          key={`frag-${ind}-${indx}-${index}`}
          className="d-flex flex-column align-items-center"
          style={{ width: `${200 / (flight.StopCount + 1)}px` }}
        >
          <Tooltip
            position={'top'}
            content={`${this.props.intl.formatMessage({
              id: 'booking.stopin',
              defaultMessage: 'booking.stopin',
            })} ${flight.Flights[index].ArrivalAirport.Name[name]}${
              flight.Flights.length > 1 &&
              index + 1 <= flight.Flights.length &&
              flight.Flights[index + 1] &&
              ` (${dateDiff(
                flight.Flights[index + 1].DepartureDateTime,
                flight.Flights[index].ArrivalDateTime,
              )}`
            })`}
            direction={direction}
            backgroundColor="warning"
            textColor="dark"
          >
            <div className="d-flex  font-smaller pointer text-primary-light">
              {flight.Flights[index].ArrivalAirport.Code}
            </div>
          </Tooltip>
          <div
            key={`stop-${ind}-${indx}-${index}-${flight.Flights[index].ArrivalAirport.Name[name]}`}
            className="py-0"
            aria-hidden="true"
          >
            <CircleIcon size={12} color="#00798c" />
          </div>
        </div>
      ));
    }
  }
  //show modal for price detail
  renderAdultPrice = (item, index) => {
    return (
      <div className="w-100 d-flex flex-column align-items-center justify-content-center font-weight-bold py-1 pb-xl-2 pb-xxl-0">
        <div className="d-flex w-100 justify-content-center align-items-center  text-secondary font-smaller font-xxl-msmall text-nowrap text-captalize ">
          <FormattedMessage
            id="booking.adultprice"
            defaultMessage="booking.adultprice"
          />
        </div>

        <div className=" d-flex w-100  font-small font-xxl-large  m-0  align-items-center justify-content-center ">
          <FormatLastNumberColor
            number={
              item.AdultPrice.Commission
                ? item.AdultPrice.TotalPrice + item.AdultPrice.Commission
                : item.AdultPrice.TotalPrice
            }
            mainColor={'dark text-center  m-0 font-weight-bold px-1 '}
            lastColor={'third'}
          />
          <div
            onMouseOut={() => this.hidePriceModal()}
            onMouseOver={() => this.setPriceList(item, index)}
            className="cursor-pointer  d-md-flex d-md-block d-none d-sm-none  "
            aria-hidden="true"
          >
            <InfoCircleIcon color={'#6c757d'} size={18} />
          </div>
          {/* <div
            className="d-flex align-items-center cursor-pointer"
          
          > */}
          {/* <span className="font-small px-1 d-flex text-primary">
                <FormattedMessage
                  id="booking.toman"
                  defaultMessage="booking.toman"
                />
              </span> */}

          {/* </div> */}
        </div>
      </div>
    );
  };
  // show flight duration  and remain seat
  renderRemainSeatAndFlightDuration = (item, index, derik) => {
    let { direction } = this.props.language;
    return (
      <div
        className={`d-md-flex col-md-2 d-sm-none d-md-block d-none  justify-content-center  align-items-around  p-0 font-weight-bold`}
      >
        <div
          className={`d-flex flex-column w-100  justify-content-${
            parseInt(derik) > 0 ? 'around' : 'center'
          } font-xsmall font-xxl-smaller`}
        >
          {/* show remain seat */}
          <div
            className={`d-flex  justify-content-center text-captalize align-items-center text-secondary ${
              parseInt(derik) > 0 ? '' : 'pb-3'
            }`}
          >
            {direction === 'ltr' ? (
              <span className="px-2">
                <CabinTypeIcon size={18} color={'#3d4a8f'} />
              </span>
            ) : null}

            <span
              className={` font-weight-bold m-0 font-weight-bold ${
                direction === 'ltr' ? 'pt-1  font-small ' : ''
              }`}
            >
              {item?.Flights[0]?.BookingClassAvails?.ResBookDesigQuantity &&
              item?.Flights[0]?.BookingClassAvails?.ResBookDesigQuantity.toLowerCase() !==
                'c'
                ? item?.Flights[0]?.BookingClassAvails?.ResBookDesigQuantity
                : '0'}
            </span>

            {direction === 'rtl' ? (
              <span className="px-1 text-third ">
                {this.props.intl.formatMessage({ id: 'booking.remainseat' })}
              </span>
            ) : null}
          </div>

          <div
            className={`d-flex justify-content-center  text-truncate   text-third`}
          >
            <FormattedMessage
              id="booking.duration"
              defaultMessage="booking.duration"
            />
            {/* show flight duration  */}
            <span className="text-primary-light px-1 font-weight-bold ">{` :  ${[
              item?.ElapsedTime.slice(0, 2),
              ':',
              item?.ElapsedTime.slice(2, 4),
            ].join('')}`}</span>
          </div>
          {parseInt(derik) > 0 ? (
            <div
              className={`d-flex align-items-center justify-content-center text-third   px-0 `}
            >
              <CoinIcon color="goldenrod" size={16} />
              {/* show user point */}
              <span className=" px-1  ">
                {derik ? numberWithCommas(parseFloat(derik).toFixed(2)) : 0}
              </span>
              <span>
                <FormattedMessage
                  id="booking.userpoint"
                  defaultMessage="booking.userpoint"
                />
              </span>
            </div>
          ) : (
            ''
          )}
        </div>
      </div>
    );
  };

  renderPriceDetailModal = (item, isAgency = false) => {
    let { priceList } = this.state,
      { parsedQueryStr } = this.props;
    return (
      <PriceDetails
        priceList={priceList}
        parsedQueryStr={parsedQueryStr}
        item={item}
        intl={this.props.intl}
        isAgency={isAgency}
      />
    );
  };
  checkAvalisReaminSeat = (item, index) => {
    let notAvails = [];
    item.Itineraries.map((itenery) => {
      if (
        itenery.Flights.filter(
          (flight) =>
            flight?.BookingClassAvails?.ResBookDesigQuantity.toLowerCase() ===
            'c',
        ).length
      )
        notAvails.push(index);
    });
    return notAvails.length === 0;
  };
  returnFlightIcon = (flightIndex, flightlength, direction) => {
    return flightIndex == 0 || flightlength > 2 ? (
      direction === 'rtl' ? (
        <DepartureAirplaneIcon size={18} color={'#3d4a8f'} />
      ) : (
        <ArrivalAirplaneIcon size={18} color={'#3d4a8f'} />
      )
    ) : direction === 'rtl' ? (
      <ArrivalAirplaneIcon size={18} color={'#3d4a8f'} />
    ) : (
      <DepartureAirplaneIcon size={18} color={'#3d4a8f'} />
    );
  };
  renderFlightList = () => {
    let { name, direction } = this.props.language,
      { flightList, user, filterPanelFlag } = this.props,
      { take } = this.state,
      profileId = localStorage.getItem('profile'),
      isAgency =
        user?.userInfo?.profiles && profileId && profileId !== 'individual';

    //sort ascending list of flight by price
    if (flightList.length > 0 && !filterPanelFlag) {
      //show flight with take count
      flightList = flightList.slice(0, take);
      return flightList.map((item, index) => {
        let hasSeat = this.checkAvalisReaminSeat(item, index);
        return (
          <div
            onClick={() => {
              window.screen.width <= 768 && hasSeat
                ? this.props.selectRow(index, item)
                : null;
            }}
            key={`flighLst-${index}`}
            className={`position-relative col-12 p-0 font-weight-bold text-left card border-sm-3 border-muted 
          border-md-1 border-2 fllight-card-border-radius ${
            index == flightList.length - 1 ? '' : 'mb-5 mb-md-3 mb-xl-4 '
          } bg-white `}
          >
            <div className="col-12 p-0  position-relative card-body d-block d-md-flex">
              {this.props.flightType !== 'onewaytrip' ? (
                <div
                  className={`position-absolute d-block rounded-circle circleBorder   ${
                    direction === 'rtl' ? 'border-right' : 'border-left'
                  }  border-2 border-third`}
                  style={{
                    right: direction === 'ltr' && '-0.8rem',
                    left: direction === 'rtl' && '-0.8rem',
                    top: '45%',
                  }}
                ></div>
              ) : (
                <></>
              )}
              <div
                className={`position-relative col-md-9 col col-sm-12 d-flex px-0 pb-3 pt-1 flex-wrap `}
              >
                {!hasSeat && (
                  <div
                    className="position-absolute d-md-none d-flex bg-third p-2 text-white default-border-radius-small font-smaller"
                    style={{
                      top: '10px',
                      left: direction === 'rtl' ? '10px' : '',
                      right: direction === 'ltr' ? '10px' : '',
                    }}
                  >
                    <FormattedMessage id="booking.noseatresult" />
                  </div>
                )}
                {item.Itineraries.map((flight, flightIndex) => (
                  <React.Fragment key={`flightItems_${flightIndex}`}>
                    <div
                      className={`d-flex col-12 ${
                        flightIndex == 0
                          ? 'pb-1'
                          : flightIndex == item.Itineraries.length - 1
                          ? 'pt-1'
                          : 'py-1'
                      } p-0 m-0 position-relative`}
                      key={`flightItem-${flightIndex}`}
                    >
                      {flightIndex !== item.Itineraries.length - 1 ? (
                        <div
                          className={`position-absolute d-block rounded-circle circleBorder  ${
                            direction === 'ltr' ? 'border-right' : 'border-left'
                          }  border-2 border-third`}
                          style={{
                            left: direction === 'ltr' && '-0.8rem',
                            right: direction === 'rtl' && '-0.8rem',
                          }}
                        ></div>
                      ) : (
                        <></>
                      )}

                      <div className="d-flex w-100 flex-column justify-content-around">
                        <div className="font-weight-normal text-secondary font-smaller font-sm-msmall font-md-smaller   d-flex  justify-content-start align-items-center px-2">
                          <div className="d-flex w-100 align-items-center px-2 px-sm-2 px-md-3 pt-1 font-weight-bold  ">
                            {this.returnFlightIcon(
                              flightIndex,
                              item.Itineraries.length,
                              direction,
                            )}

                            {item.Itineraries.length == 2 ? (
                              <span className="text-primary px-2 text-nowrap">
                                <FormattedMessage
                                  id={`booking.${
                                    flightIndex === 0
                                      ? 'departureflight'
                                      : 'returnflight'
                                  }`}
                                />
                              </span>
                            ) : item.Itineraries.length > 2 ? (
                              <span className="text-primary px-2 text-nowrap">{`${this.props.intl.formatMessage(
                                { id: 'header.book' },
                              )} ${flightIndex + 1}`}</span>
                            ) : null}
                            <span className={` p-1 text-secondary text-nowrap`}>
                              {name === 'fa'
                                ? `${returnWeeekDay(
                                    flight.Flights[0].DepartureDateTime.split(
                                      'T',
                                    )[0],
                                    name,
                                    false,
                                  )} ${returnShamsiDayWithMonthName(
                                    momentjs(
                                      flight.Flights[0].DepartureDateTime.split(
                                        'T',
                                      )[0],
                                      'YYYY-M-D',
                                    ).format('jYYYY-jMM-jDD'),
                                    name,
                                  )}
                            ، ${returnDayWithMonthName(
                              flight.Flights[0].DepartureDateTime.split('T')[0],
                              name,
                            )}`
                                : `${returnWeeekDay(
                                    flight.Flights[0].DepartureDateTime.split(
                                      'T',
                                    )[0],
                                    name,
                                    false,
                                  )}   ${returnDayWithMonthName(
                                    flight.Flights[0].DepartureDateTime.split(
                                      'T',
                                    )[0],
                                    name,
                                  )}`}
                            </span>
                          </div>
                        </div>

                        <div
                          className={`d-flex w-100 justify-content-around px-4 px-xxl-5 ${
                            flightIndex === item.Itineraries.length - 1
                              ? 'pb-1'
                              : 'pb-0'
                          }`}
                        >
                          <div
                            className={`d-flex flex-column p-0 justify-content-center align-items-center col-2  `}
                          >
                            {/* show flight for origin and destination */}
                            {this.renderAirplaneIcon(
                              flight.Flights,
                              flightIndex,
                            )}
                          </div>

                          {/* show all airport info like name and time */}
                          {this.renderCityInfo(flight, flightIndex, index)}
                          <div className="col-1 col-md-2 d-block d-sm-block d-md-none px-3 px-sm-4 px-md-0"></div>
                          {/* show remain seat and flight duration */}
                          {this.renderRemainSeatAndFlightDuration(
                            flight,
                            index,
                            item.Derik,
                          )}
                        </div>
                      </div>
                    </div>

                    {flightIndex !== item.Itineraries.length - 1 ? (
                      <div className="d-flex w-100  justify-content-end px-5">
                        <div
                          className="w-100"
                          style={{
                            borderTop: '1px dashed gray',
                          }}
                        ></div>
                      </div>
                    ) : (
                      <></>
                    )}
                  </React.Fragment>
                ))}
              </div>

              <div className="col-md-3 d-md-flex align-items-center justify-content-center px-0 position-relative d-sm-none d-md-block d-none ">
                <div
                  className={`d-flex col-8 h-100 px-0  py-2 flex-column text-center justify-content-center`}
                >
                  {/* show adult price  */}
                  <div className="d-flex flex-column align-items-center justify-content-center flex-fill">
                    {this.renderAdultPrice(
                      item,
                      index,
                      isAgency,
                      this.props.totalPassenger === 1,
                    )}

                    {/* call select flight function in select flight and save it in local storage and redirect to next page*/}
                    <div
                      className={`d-flex flex-column align-items-center justify-content-center px-2 mb-1 pb-4 w-100 ${
                        item.Itineraries.length > 1
                          ? this.props.totalPassenger > 1
                            ? 'pt-4'
                            : 'pb-4'
                          : 'py-2'
                      } `}
                    >
                      <button
                        name={`selectFlight-info-${index}`}
                        id={`selectFlight-info-${index}`}
                        className={` ${
                          hasSeat
                            ? 'btn-secondary text-white '
                            : 'btn-third text-dark'
                        } cursor-pointer border-0  w-100  font-smaller font-xxl-small p-2  d-flex align-items-center 
                        justify-content-center mb-1 default-border-radius`}
                        onClick={() => {
                          hasSeat ? this.props.selectFlight(item) : null;
                          // : this.setState({ showModal: true });
                        }}
                      >
                        {hasSeat ? (
                          <FormattedMessage
                            id="booking.selectflight"
                            defaultMessage="booking.selectflight"
                          />
                        ) : (
                          <FormattedMessage
                            id="booking.noseatresult"
                            defaultMessage="booking.noseatresult"
                          />
                        )}
                      </button>

                      {/* show total price when we have more than 1 passenger  */}

                      {this.props.totalPassenger > 1 ? (
                        <div
                          className={` d-flex flex-column align-items-cenetr font-msmall justify-content-center pt-2  text-center text-third`}
                        >
                          <FormattedMessage
                            id="booking.totalprice"
                            defaultMessage="booking.totalprice"
                          />
                          <span className="text-center text-captalize text-primary-light  font-weight-bold  font-small">
                            {`${numberWithCommas(
                              // !isAgency &&
                              item.Commission &&
                                item.Commission !== undefined &&
                                item.Commission / 10 !== 0
                                ? (
                                    (item.TotalPrice + item.Commission) /
                                    10
                                  ).toFixed(0)
                                : (item.TotalPrice / 10).toFixed(0),
                            )}`}
                          </span>
                        </div>
                      ) : null}
                      {item.Commission && isAgency ? (
                        <div
                          className={`text-center pb-1 text-third font-msmall`}
                        >
                          <FormattedMessage
                            id="booking.agenycommission"
                            defaultMessage="booking.agenycommission"
                          />
                          <span className="text-center text-captalize text-primary font-weight-bold  font-small">
                            {`: ${numberWithCommas(
                              Math.abs((item.Commission / 10).toFixed(0)),
                            )}`}
                          </span>
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div
                    // set cuurent index to handle with flight open or close
                    onClick={(event) => {
                      event.stopPropagation();
                      this.selectRow(index);
                    }}
                    className="d-flex text-gray p-0 text-captalize  align-items-center  justify-content-center cursor-pointer font-smaller font-xxl-msmall"
                  >
                    {this.state.selectedRow === index ? (
                      <UpOutlineIcon size={20} color={'gray'} />
                    ) : (
                      <DownOutlineIcon size={20} color={'gray'} />
                    )}

                    <FormattedMessage
                      id="booking.showflightdetail"
                      defaultMessage="booking.showflightdetail"
                    />
                  </div>
                </div>
              </div>

              <div className="d-md-none position-relative w-100">
                <div
                  className="d-sm-block flight-mobile-cost d-block d-md-none default-border-radius position-absolute border border-2 border-muted bg-white col-10"
                  style={{
                    left: '50%',
                    transform: `translate(-50%,50%)`,
                  }}
                >
                  {this.renderAdultPrice(item, index, isAgency)}
                </div>
              </div>
            </div>

            {index === this.state.currentIndex && (
              <div
                className="text-center col-md-6 position-absolute "
                style={{ zIndex: 50, top: 0, left: '23%', fontSize: '1rem' }}
              >
                {this.renderPriceDetailModal(item, isAgency)}
              </div>
            )}
            <div
              className="col-12 w-100 d-felx  p-0 "
              style={{ overflow: 'hidden' }}
            >
              {this.renderSelectedRow(index, item.Itineraries, item)}
            </div>
          </div>
        );
      });
    }
  };

  // show flight details
  renderSelectedRow = (index, list, flight) => {
    let { airLineLst, flightType, parsedQueryStr } = this.props;
    if (this.state.selectedRow === index)
      return (
        <div
          className="font-weight-bold d-flex col-12  p-0 card border-0 shadow-sm default-border-radius-small"
          style={{ color: '#55266c' }}
        >
          <div className="col-12 p-0 flex-wrap  d-none d-sm-none  d-md-block default-border-radius ">
            <FlightDetails
              details={convertToCamelCase(list)}
              airLineLst={airLineLst}
              flightType={flightType}
              flight={flight}
              parsedQueryStr={parsedQueryStr}
              flightIndex={index}
            />
          </div>
        </div>
      );
  };
  // icon for show more with arrow key
  renderShowMore = (index) => {
    let { showMoreFlag } = this.state;
    let { direction } = this.props.language;
    return (
      <div
        className="d-flex align-items-center justify-content-center"
        style={{ transform: 'rotate( 90deg )' }}
      >
        <div className="font-smaller justify-content-center align-items-center  d-flex px-2">
          {direction === 'ltr' && (
            <React.Fragment>
              <FormattedMessage
                id="booking.details"
                defaultMessage="booking.details"
              />
              <span
                style={{
                  transform: showMoreFlag[index]
                    ? 'rotate(90deg)'
                    : 'rotate(-90deg)',
                }}
                className={`p-2 `}
              >
                <ChevronDownIcon size={16} color="#3d4a8f" />
              </span>
            </React.Fragment>
          )}
          {direction === 'rtl' && (
            <React.Fragment>
              <span
                style={{
                  transform: showMoreFlag[index]
                    ? 'rotate(90deg)'
                    : 'rotate(-90deg)',
                }}
                className={`p-2 `}
              >
                <ChevronDownIcon size={16} color="#3d4a8f" />
              </span>
              <FormattedMessage
                id="booking.details"
                defaultMessage="booking.details"
              />
            </React.Fragment>
          )}
        </div>
      </div>
    );
  };

  renderAirplaneIcon(flight, ind, type) {
    let { name, direction } = this.props.language;
    let allAirlines = [
      ...new Set(flight.map((t) => [t.OperatingAirline])),
    ].reduce((a, b) => {
      return a.concat(b);
    });
    let operatingAirline = [
      ...new Map(allAirlines.map((item) => [item.Code, item])).values(),
    ];

    if (flight && flight.length > 0 && operatingAirline.length) {
      return (
        <div className={`d-flex flex-column `}>
          <div
            className="d-flex justify-content-center  w-100 position-relative  "
            style={{ zIndex: 0 }}
          >
            {operatingAirline.map((item, index) => {
              let position = -30 * index;
              return (
                <img
                  key={`img-${index}`}
                  style={{
                    width: 34,
                    height: 34,
                    zIndex: operatingAirline.length - index,
                    marginRight:
                      direction === 'ltr'
                        ? operatingAirline.length === 1 || index === 0
                          ? '0px'
                          : `${position}px`
                        : '0px',
                    marginLeft:
                      direction === 'rtl'
                        ? operatingAirline.length === 1 || index === 0
                          ? '0px'
                          : `${position}px`
                        : '0px',
                  }}
                  title={item.Name[name]}
                  className={`d-flex  rounded-circle bg-white border border-1 p-1 ${
                    index === 0 ? '' : 'position-absolute'
                  }
                   
                   `}
                  src={returnAirlineLogos(item.Code)}
                  alt="type"
                />
              );
            })}
          </div>

          {operatingAirline.length === 1 ? (
            <div
              className="d-flex  w-100 justify-content-center font-weight-bold text-third text-nowrap  pt-2 
            font-smaller font-sm-smaller font-md-xsmall font-lg-small font-xl-msmall "
            >
              {operatingAirline[0].Name[name]}
            </div>
          ) : (
            <div className="d-flex  w-100 align-items-start text-third   text-center font-weight-bold position-relative font-sm-smaller font-smaller font-md-small">
              {this.props.intl.formatMessage({
                id: 'booking.multiairline',
              })}
            </div>
          )}
        </div>
      );
    }
  }

  renderShowMoreFlight = () => {
    if (this.state.showMore)
      return (
        <div className="d-flex w-100 my-3 justify-content-center">
          <Button
            name={`show-more-flight`}
            id={`show-more-flight`}
            onClick={() => this.ShowMoreFlight()}
            label={this.props.intl.formatMessage({
              id: 'booking.showmore',
            })}
          />
        </div>
      );
  };
  render() {
    return (
      <div id="mainSelectFlighContainer">
        {this.renderFlightList()}
        {this.renderShowMoreFlight()}
        {this.renderWantFlightModal()}
      </div>
    );
  }
  //#endregion
}
function mapStateToProps(state) {
  return {
    language: state.language,
    user: state.user,
  };
}
//#region propTypes and default props
FlightInformation.propTypes = {
  parsedQueryStr: propTypes.object,
  flightType: propTypes.string,
  flightList: propTypes.array,
  totalPassenger: propTypes.number,
  airLineLst: propTypes.array,
  filterPanelFlag: propTypes.bool,
};
FlightInformation.defaultProps = {
  parsedQueryStr: {},
  flightType: 'oneway',
  flightList: [],
  totalPassenger: 1,
  airLineLst: [],
  filterPanelFlag: false,
};
//#endregion
export default injectIntl(
  connect(mapStateToProps)(withRouter(FlightInformation)),
);
